<template>
    <div class="astro-form">
        <date-and-city-picker
                :mode="modes.natal"
                :darkMode="darkMode"/>

        <div class="astro-select-maps"
             :class="{'active' : !!additionalMapsCollapsed}"
             :disabled="!userLoggedIn"
             ref="astroSelectMaps"
             v-if="!!showAdditionalMaps">
            <div class="asm-header"
                 @click="toggleAdditionalMaps">
                <span>Дополнительные карты</span>
            </div>
            <div class="asm-disabled-text"
                 ref="asmDisabledText"
                 v-if="!userLoggedIn">
                <template v-if="!userLoggedIn">
                    Зарегистрируйтесь, для построения дополнительных карт
                </template>
            </div>
            <div class="asm-block-wrapper"
                 v-if="!!userLoggedIn"
                 ref="additionalMapsWrapper">
                <div class="asm-block">
                    <div class="asm-left">
                        <div class="asm-help"
                             ref="asmHelp"
                             v-show="!!mode"/>
                        <div class="asm-help-text"
                             ref="asmHelpText">
                            <span v-show="mode === modes.transit">
                                Транзит - отображение реального положения элементов Неба и их влияние на общий и ваш личный энергетический статус, внешний событийный поток и события жизни.
                            </span>
                            <span v-show="mode === modes.direction">
                                Дирекция - отображение символического движения персональных элементов Неба в вашей карте, которое показывает внешние события и ситуации, создающиеся для вашего развития в конкретных сферах жизни.
                            </span>
                            <span v-show="mode === modes.progression">
                                Прогрессия - отображение символического движения персональных элементов Неба в вашей карте, которое показывает ваши внутренние новые качества и энергии, которые важно проявить в мир.
                            </span>
                            <span v-show="mode === modes.multimap">
                                Мультикарта - одновременное графическое отображение всех 3-х карт (транзит, прогрессия и дирекция), которое даёт возможность видеть как внешние, так и внутренние причины событий и состояний, а также прогнозировать их наступление, результаты и окончание.
                            </span>
                        </div>
                        <div class="asm-select-wrapper">
                            <div class="asm-select"
                                 :class="{'open' : additionalMapTypesShown}"
                                 @click="toggleAdditionalMapTypes">
                                <span :class="{'selected' : !mode}"
                                      @click="pickAdditionalMapType()">Не выбрано</span>
                                <span :class="{'selected' : mode === modes.transit}"
                                      @click="pickAdditionalMapType(modes.transit)">Транзит</span>
                                <span :class="{'selected' : mode === modes.direction}"
                                      @click="pickAdditionalMapType(modes.direction)">Дирекция</span>
                                <span :class="{'selected' : mode === modes.progression}"
                                      @click="pickAdditionalMapType(modes.progression)">Прогрессия</span>
                                <!-- Мультикарта доступна только пользователям с тарифом PRO -->
                                <span :class="{'selected' : mode === modes.multimap}"
                                      v-if="!!proTariff"
                                      @click="pickAdditionalMapType(modes.multimap)">Мультикарта</span>
                            </div>
                        </div>
                    </div>
                    <div class="asm-right">
                        <div class="astro-form">
                            <date-and-city-picker
                                    :mode="modes.transit"
                                    v-show="mode === modes.transit"/>
                            <date-and-city-picker
                                    :mode="modes.progression"
                                    v-show="mode === modes.progression"/>
                            <date-and-city-picker
                                    :mode="modes.direction"
                                    v-show="mode === modes.direction"/>
                            <date-and-city-picker
                                    :mode="modes.multimap"
                                    v-if="!!proTariff"
                                    v-show="mode === modes.multimap"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="center">
            <button type="button"
                    class="button" :class="{'white-button': !!darkMode, 'blue-button': !darkMode}"
                    :disabled="!!natalFormError"
                    @click="calculate">Рассчитать
            </button>
        </div>
    </div>
</template>

<script>
    import constants from '@/constants';
    import $ from 'jquery';
    import DateAndCityPicker from '@/components/DateAndCityPicker';

    export default {
        name: 'NatalInput',

        props: ['showAdditionalMaps', 'darkMode'],

        components: {
            DateAndCityPicker
        },

        data() {
            return {
                additionalMapsCollapsed: false,
                additionalMapTypesShown: false
            }
        },

        computed: {
            mode: {
                get() {
                    return this.$store.getters.additionalMapMode;
                },

                set(mode) {
                    this.$store.dispatch('changeAdditionalMapMode', mode);
                }
            },

            modes() {
                return constants.mode;
            },

            userLoggedIn() {
                let token = this.$store.getters.token;
                return !!token && token.length > 0;
            },

            currentSubscription() {
                return this.$store.getters.currentSubscription;
            },

            proTariff() {
                return this.$store.getters.proTariff;
            },

            natalFormError() {
                return this.$store.getters.natalFormError;
            }
        },

        watch: {
            currentSubscription(val) {
                if (!val)
                    return;

                this.initHoverLogic();
            }
        },

        mounted() {
            this.initHoverLogic();
        },

        methods: {
            initHoverLogic() {
                if (!!this.showAdditionalMaps) {
                    //Обернул в nextTick потому что по непонятным причинам $refs.elem недоступен в mounted в случае,
                    //если вкаладка открыта в первый раз на странице
                    this.$nextTick(function () {
                        let asmHelpText = $(this.$refs.asmHelpText);
                        $(this.$refs.asmHelp).hover(
                            function () {
                                asmHelpText.addClass('active')
                            },
                            function () {
                                asmHelpText.removeClass('active')
                            }
                        );
                    });
                }


                if (!this.currentSubscription) {
                    //Обернул в nextTick потому что по непонятным причинам $refs.elem недоступен в mounted в случае,
                    //если вкаладка открыта в первый раз на странице
                    this.$nextTick(function () {
                        let asmDisabledText = $(this.$refs.asmDisabledText);
                        $(this.$refs.astroSelectMaps).hover(
                            function () {
                                asmDisabledText.addClass('active')
                            },
                            function () {
                                asmDisabledText.removeClass('active')
                            }
                        );
                    });
                }
            },

            toggleAdditionalMaps() {
                if (!this.userLoggedIn)
                    return;

                this.additionalMapsCollapsed = !this.additionalMapsCollapsed;

                let additionalMapsWrapper = $(this.$refs.additionalMapsWrapper);
                if (this.additionalMapsCollapsed) {
                    additionalMapsWrapper.slideDown(200);
                } else {
                    additionalMapsWrapper.slideUp(200);
                }
            },

            toggleAdditionalMapTypes() {
                this.additionalMapTypesShown = !this.additionalMapTypesShown;
            },

            pickAdditionalMapType(mode) {
                this.mode = !!mode ? mode : null;
            },

            async calculate() {
                if (!!this.natalFormError)
                    return;

                let success = await this.$store.dispatch("loadSwephData");
                if (success && this.$route.name !== 'CardCalculate') {
                    // Для редиректа на страницу расчётов с главной страницы
                    this.$store.commit('setCalculateMapFromIndexPage', true);
                    this.$router.push({name: 'CardCalculate'});
                }
            }
        }
    }
</script>